/**
 * Auth API calls
 */

import apiClient from './client.js';

export interface AuthStatus {
  authenticated: boolean;
  user_id?: string;
  is_admin: boolean;
}

export const authApi = {
  me: async (): Promise<AuthStatus> => {
    const response = await apiClient.get('/auth/me');
    return response.data;
  },
};
